import React from 'react';
import { ReadingRichText } from '@interactive-room';

/** Convierte **negrita** y ### subtítulos para impresión Neo-Swiss. */
export function PrintRichText({ text, className }: { text: string; className?: string }) {
  return <ReadingRichText text={text} className={className} />;
}

export function stripInlineMarkdown(text: string): string {
  return String(text || '')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\*([^*]+)\*/g, '$1')
    .replace(/__([^_]+)__/g, '$1')
    .replace(/^###\s+/gm, '');
}
